import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  if (loading) {
    return <div className="text-center mt-10">Loading...</div>;
  }

  
  
  if (!user) {
    // window.location.href = "/login";
    navigate("/login");
    return null;
    // return <Navigate to={`${window.location.origin}/login`} replace />;
  }

  return children;
};

export default ProtectedRoute;
